module.exports = __webpack_public_path__ + "static/optimo_tradycyjne-e7b40ba80ebb5e9640f31b78ea5eae9b.png";